module.exports = {
      id: "virgo-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-0c9f646beffa24bb04e01488ef4c0ff4.svg#virgo",
      toString: function () {
        return this.url;
      }
    }